import React from "react";
import "./gowrianandhamFeatureStyle.css";

const GowriAnandhamFeature = ({ details }) => {
  return (
    <div className="ga-feature-container">
      <div className="ga-scrolling-images">
        {details &&
          details.map((data) => {
            return (
              <div key={data.id} className="ga-feature-incontainer">
                <img src={data.imgSrc} alt={data.imgText} />
                <div className="ga-featurediv">
                  <h6>{data.title}</h6>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default GowriAnandhamFeature;
